import { Column } from 'react-table';
import { DateTimeColumn } from 'shared/tables/columns';
import { QuoteSummaryTextColumn } from 'shared/tables/columns/quote-summary-text-column';
import { QuotesSummaryItem } from 'shared/types/quotesSummary';
import { QuoteSummaryContextMenuColumn } from './quote-summary-context-menu-column';

export const quotesSummaryTableColumns: Column<QuotesSummaryItem>[] = [
  {
    Header: ' ',
    accessor: 'id',
    Cell: QuoteSummaryContextMenuColumn,
    align: 'left',
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: QuoteSummaryTextColumn,
    align: 'left',
  },
  {
    Header: 'Quote #',
    accessor: 'quoteNumber',
    Cell: QuoteSummaryTextColumn,
    align: 'left',
  },
  {
    Header: 'Customer',
    accessor: 'wholesalerCustomerNumber',
    Cell: QuoteSummaryTextColumn,
    align: 'left',
  },
  {
    Header: 'Project Name',
    accessor: 'jobInfoProjectName',
    Cell: QuoteSummaryTextColumn,
    align: 'left',
  },
  {
    Header: 'Project Type',
    accessor: 'plumberProjectType',
    Cell: QuoteSummaryTextColumn,
    align: 'left',
  },
  {
    Header: 'Brand',
    accessor: 'brand',
    Cell: QuoteSummaryTextColumn,
    align: 'left',
  },
  {
    Header: 'Rep Agency',
    accessor: 'repAgency',
    Cell: QuoteSummaryTextColumn,
    align: 'left',
  },
  {
    Header: 'Rep',
    accessor: 'requestedBy',
    Cell: QuoteSummaryTextColumn,
    align: 'left',
  },
  // {
  //   Header: 'Quote Total',
  //   accessor: 'quoteTotal',
  //   Cell: MoneyColumn,
  //   align: 'left',
  // },
  {
    Header: 'Date Submitted',
    accessor: 'dateSubmitted',
    Cell: DateTimeColumn,
    align: 'left',
  },
  {
    Header: 'Date Revised',
    accessor: 'dateRevised',
    Cell: DateTimeColumn,
    align: 'left',
  },
  {
    Header: 'Date Approved',
    accessor: 'dateApproved',
    Cell: DateTimeColumn,
    align: 'left',
  },
  {
    Header: 'Wholesaler',
    accessor: 'wholesaler',
    Cell: QuoteSummaryTextColumn,
    align: 'left',
  },
  {
    Header: 'Plumber',
    accessor: 'plumberContractor',
    Cell: QuoteSummaryTextColumn,
    align: 'left',
  },
  {
    Header: 'Job State',
    accessor: 'jobInfoStateName',
    Cell: QuoteSummaryTextColumn,
    align: 'left',
  },
  {
    Header: 'Approver',
    accessor: 'approvedBy',
    Cell: QuoteSummaryTextColumn,
    align: 'left',
  },
  {
    Header: 'Revision Approver',
    accessor: 'revisionApprovedBy',
    Cell: QuoteSummaryTextColumn,
    align: 'left',
  },
  {
    Header: 'Last Modified By',
    accessor: 'lastModifiedBy',
    Cell: QuoteSummaryTextColumn,
    align: 'left',
  },
];
